import React from 'react';
import {
  SaveButton,
  UPDATE,
  fetchEnd,
  fetchStart,
  showNotification,
  refreshView
} from 'react-admin';
import { connect } from 'react-redux';

import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import dataProvider from '../../core/providers/IccUserDataProvider';
import DialogTitleWithCloseButton from '../../core/components/DialogTitleWithCloseButton';
import GroupCategoryApi from '../../core/apis/GroupCategoryApi';
import GroupCategoryForm from './GroupCategoryForm';
import { getIcError } from '../../core/providers/utils';

class GroupCategoryCreateUpdate extends React.Component {
  groupCategoryFormProps;

  state = {
    submitting: false
  };

  setGroupCategoryFormProps = props => {
    this.groupCategoryFormProps = props;
  };

  handleSaveClick = event => {
    // Trigger a submit of our custom quick create/update form
    // This is needed because our modal action buttons are oustide the form
    this.groupCategoryFormProps.form.submit(event);
  };

  handleClose = () => {
    const { handleDialogToggle } = this.props;
    const { submitting } = this.state;
    if (submitting) return;
    this.groupCategoryFormProps.form.reset();
    handleDialogToggle();
  };

  handleSubmit = values => {
    const {
      operation,
      fetchStart,
      fetchEnd,
      showNotification,
      handleDialogToggle,
      refreshView
    } = this.props;

    this.setState({ submitting: true });

    // Prepare the list of groupcategories to create
    const groupcategories = [];
    if (operation === 'Create') {
      if (values.groupId) {
        values.categoryOrSubcategoryIds.forEach(categoryOrSubcategoryId => {
          groupcategories.push({
            groupId: values.groupId,
            categoryOrSubcategoryId
          });
        });
      } else {
        values.groups.forEach(groupId => {
          groupcategories.push({
            groupId,
            categoryOrSubcategoryId: values.categoryOrSubcategoryId
          });
        });
      }
    }

    // Dispatch an action letting react-admin know a API call is ongoing
    fetchStart();

    // As we want to know when the new groupcategories has been created/updated in order to close the modal, we use the
    // dataProvider directly to update, and async api call to create many
    const crudOperation =
      operation === 'Create'
        ? GroupCategoryApi.create(groupcategories)
        : dataProvider(UPDATE, 'groupcategories', {
            data: {
              groupId: values.groupId,
              categoryOrSubcategoryId: values.categoryOrSubcategoryId
            }
          });

    crudOperation
      .then(() => {
        refreshView();
        handleDialogToggle();
      })
      .catch(error => {
        showNotification('ra.notification.server', 'error', {
          messageArgs: { message: getIcError(error) }
        });
      })
      .finally(() => {
        // Dispatch an action letting react-admin know a API call has ended
        this.groupCategoryFormProps.form.reset();
        fetchEnd();
        this.setState({ submitting: false });
      });
  };

  render() {
    const { operation, showDialog, groupId } = this.props;
    const { submitting } = this.state;

    return (
      <Dialog
        fullWidth
        open={showDialog}
        aria-label={`${operation} fund investor`}
        maxWidth="sm"
        onClose={(event, reason) => {
          if (reason === 'backdropClick') return null;
          this.handleClose();
        }}
      >
        <DialogTitleWithCloseButton onClose={this.handleClose}>
          {operation === 'Create'
            ? groupId
              ? 'Add Existing Category to Group'
              : 'Add Existing Group to Category'
            : operation + 'fund category'}
        </DialogTitleWithCloseButton>
        <DialogContent>
          <GroupCategoryForm
            {...this.props}
            setGroupCategoryFormProps={this.setGroupCategoryFormProps}
            handleSubmit={this.handleSubmit}
          />
        </DialogContent>
        <DialogActions>
          <SaveButton
            saving={submitting}
            handleSubmitWithRedirect={this.handleSaveClick}
            label={operation === 'Create' ? 'Add' : operation}
            icon={<></>}
          />
          <Button
            onClick={this.handleClose}
            variant="outlined"
            color="primary"
            disabled={submitting}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

const mapDispatchToProps = {
  fetchEnd,
  fetchStart,
  showNotification,
  refreshView
};

export default connect(null, mapDispatchToProps)(GroupCategoryCreateUpdate);
